import { useGroupDashboardContext } from '../../../GroupDashboardContext'
import { RawUserData } from '../../types/userDetails'
import { isTimestamp } from '../../utils'

export type EnrolledUserData = {
  userId: string
  name: string
  email: string
  dateEnrolled: string
  dateCompleted: string
  dateExpiration: string
  completePercentage: string
  certificateLink: string,
  avatarUrl: string
  steps: object
}[]

const transformUserData = (originalData: RawUserData | null, courseId: number): EnrolledUserData => {
  if (!originalData) {
    return []
  }

  const { selectedTeamType } = useGroupDashboardContext()

  let results =  []

  originalData.map(user => {
    const userId = user?.id ?? ''
    const name = user?.name ?? ''
    const email = user?.email ?? ''
    const avatarUrl = user?.avatar_url ?? ''
    const progress = user?.progress?.find(p => Number(p.course_id) === courseId) ?? null
    const dateEnrolled = progress && isTimestamp(progress.course_enrolled)
      ? new Date(Number(progress.course_enrolled) * 1000).toDateString()
      : '-'
    const dateCompleted = progress && isTimestamp(progress.course_completed)
      ? new Date(Number(progress.course_completed || 0) * 1000).toDateString()
      : '-'
    const dateExpiration = progress && isTimestamp(progress.course_expiration)
      ? new Date(Number(progress.course_expiration || 0) * 1000).toDateString()
      : '-'
    const completePercentage = progress
      ? Math.trunc(Number(progress.completeness_percentage)).toString()
      : '0'
    const steps = progress?.steps_progress ?? {}
    const certificateLink = progress?.certificate_link ?? ""

    if ( progress || selectedTeamType === 'wooteams' ) {
      results.push({
        userId,
        name,
        email,
        dateEnrolled,
        dateCompleted,
        dateExpiration,
        completePercentage,
        certificateLink,
        avatarUrl,
        steps,
        progress: user?.progress ?? [],
        lastActivityUnix: user?.last_activity ?? 0,
      })
    }
  })

  return results
}

export const CourseUserReportData = (data: RawUserData, courseId: number) => {
  return transformUserData(data, courseId)
}
